import HorizontalTable from '../components/horizontal-table/horizontal-table';
import { TitleHeadPrescription } from '../mocks/data';
import PanelStatus from '../components/panel-status/panel-status';
import PageHead from '../components/page-head/page-head';
import { filterConfigPrescriprion, initialFilterOpenPrescriprion, initialFilterPrescriprion } from '../components/dataForFilters/prescription/filtersDataPrescription';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterForPlanAction from '../../vpo/components/planAction/filterForPlanAction/FilterForPlanAction';
import { isEqual } from 'lodash';
import { actionStatusGos, directionsGos, locationsGos, prescriptionStatusGos, gosViolations, SettingsListName } from '../api/config/gos.config';
import { selectItems } from 'src/modules/spItems/selectors';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { getItems } from 'src/modules/spItems/actions';
import { UrlGOS } from '../api/constant/Constants';
import { generatePrescriptions } from '../utils/utils';

import { myTaskActionsListName, MyTaskActionsListFieldsType } from 'src/api/config/myTasksActions.config';
import React from 'react';
import { AdditionalFilters, FilterKey, FilterValue, SelectionFilterValue } from '../types/typesGos';
import { selectCurrentUser, selectUsers } from 'src/modules/users/selector';
import { addUsers } from 'src/modules/users/actions';
import NoAccess from '../components/no-access/no-access';
import { selectModelData } from '../store/filterData/selector';
import { fetchData } from '../store/filterData/actions';
import { transformDataForFilters } from '../utils/utilsGOS';
import { selectLastUpdatedId } from '../store/addForms/selector';
import { fetchSettingsRequest } from '../store/settings/settings';
import { extractStrapiData, getDataGOS } from '../api/api';

function Gos() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const [currentFilters, setCurrentFilters] = useState(initialFilterPrescriprion);
  const [prevFilters, setPrevFilters] = useState(initialFilterPrescriprion);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageViolations, setCurrentPageViolations] = useState(1);
  const [filterChangeCounter, setFilterChangeCounter] = useState(0);
  const [filterChangeCounterViolations, setFilterChangeCounterViolations] = useState(0);
  const [localPrescriptions, setLocalPrescriptions] = useState<any[]>([]);
  const [localViolations, setLocalViolations] = useState<any[]>([]);

  useEffect(() => {
    const prescriptionId = searchParams.get('prescriptionCard');
    if (prescriptionId) {
      getDataGOS('gos-prescriptions', { 'filters[id][$eq]': prescriptionId }).then((response) => {
        const data = extractStrapiData(response);
        if (data && data.length > 0) {
          setLocalPrescriptions(data);
        }
      });
    }
  }, []);
  const itemsPerPage = 75;
  // const lastIDForm = useAppSelector((state) => selectJustAddedItem(state, prescriptionGos));
  const idUpdateFormPres = useAppSelector((state) => selectLastUpdatedId(state, 'gos-prescriptions'));
  const idUpdateViolation = useAppSelector((state) => selectLastUpdatedId(state, 'gos-violations'));
  // const idDeleteFormPres = useAppSelector((state) => selectJustDeletedItem(state, prescriptionGos));

  //! Изменил: данные со страпи приходят
  const locationFilter = useAppSelector((state: any) => selectModelData(state, 'gos-locations'));
  const directionFilter = useAppSelector((state: any) => selectModelData(state, 'gos-directions'));
  const prescriptionStatusFilter = useAppSelector((state: any) => selectModelData(state, 'gos-prescription-statuses'));
  const actionStatusFilter = useAppSelector((state: any) => selectModelData(state, 'gos-action-statuses'));
  const prescriptionsData = useAppSelector((state: any) => selectModelData(state, 'gos-prescriptions'));
  const ViolationsGos = useAppSelector((state: any) => selectModelData(state, 'gos-violations'));

  const prescriptionsLoading = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-prescriptions']?.loading);
  const prescriptionsPagination = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-prescriptions']?.pagination);
  const violationsLoading = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-violations']?.loading);
  const violationsPagination = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-violations']?.pagination);

  const hasNextPage = prescriptionsPagination ? prescriptionsPagination.page < prescriptionsPagination.pageCount : false;
  const hasNextPageViolations = violationsPagination ? violationsPagination.page < violationsPagination.pageCount : false;

  const users: any = useAppSelector(selectUsers);
  const user = useAppSelector(selectCurrentUser);
  const userStatus = useAppSelector((state) => state.users.statusCurrent);

  //! Получаю локации, направлений, статусы предписаний и действий
  useEffect(() => {
    dispatch(fetchSettingsRequest());
    dispatch(
      fetchData(
        'gos-locations',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
    dispatch(
      fetchData(
        'gos-directions',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
    dispatch(
      fetchData(
        'gos-prescription-statuses',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
    dispatch(
      fetchData(
        'gos-action-statuses',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
  }, [dispatch]);

  useEffect(() => {
    const userEmails = localPrescriptions.map((prescription) => prescription.ResponsibleEmail || prescription.Responsible?.Email).filter(Boolean);
    if (userEmails.length > 0) {
      dispatch(addUsers(userEmails));
    }
  }, [localPrescriptions]);

  useEffect(() => {
    dispatch(getItems({ listName: myTaskActionsListName, filters: { ImportantHashTag: `#${'Предписание'}*` } }));
  }, [dispatch]);

  const actions: MyTaskActionsListFieldsType[typeof myTaskActionsListName][] = useAppSelector((state) => selectItems(state, myTaskActionsListName));


  //! трансформация фильтров под страпи
  const transformedLocations = React.useMemo(() => transformDataForFilters(locationFilter), [locationFilter]);
  const transformedDirections = React.useMemo(() => transformDataForFilters(directionFilter), [directionFilter]);
  const transformedStatusPrescriptions = React.useMemo(() => transformDataForFilters(prescriptionStatusFilter), [prescriptionStatusFilter]);
  const transformedActionStatuses = React.useMemo(() => transformDataForFilters(actionStatusFilter), [actionStatusFilter]);

  const filterConfigs = {
    location: { items: transformedLocations },
    direction: { items: transformedDirections },
    statusPrescription: { items: transformedStatusPrescriptions },
    status: { items: transformedActionStatuses },
  };

  const filtersMap = {
    location: transformedLocations,
    direction: transformedDirections,
    statusPrescription: transformedStatusPrescriptions,
    status: transformedActionStatuses,
  };

  const handleFiltersChange = useCallback(
    (newFilters: any) => {
      if (!isEqual(currentFilters, newFilters)) {
        // console.log('Новые фильтры:', newFilters);
        setLocalPrescriptions([]);
        setCurrentPage(1);
        setCurrentFilters(newFilters);
      }
    },
    [currentFilters]
  );

  const filterMappings = {
    prescriptions: {
      location: 'GOSLocation',
      direction: 'Direction',
    },
  };

  const getFormattedFilters = React.useCallback(() => {
    const additionalFilters: AdditionalFilters = {};

    if (currentFilters.created?.startDate) {
      additionalFilters['DateVerification][$gte'] = currentFilters.created.startDate;
    }
    if (currentFilters.created?.endDate) {
      additionalFilters['DateVerification][$lte'] = currentFilters.created.endDate;
    }
    if (currentFilters.dataTable?.startDate) {
      additionalFilters['DeadlineExecutionOrder][$gte'] = currentFilters.dataTable.startDate;
    }
    if (currentFilters.dataTable?.endDate) {
      additionalFilters['DeadlineExecutionOrder][$lte'] = currentFilters.dataTable.endDate;
    }

    if (currentFilters.responsible && currentFilters.responsible?.selected?.length > 0) {
      additionalFilters.ResponsibleEmail = currentFilters.responsible.selected;
    }

    function isFilterKey(key: string): key is FilterKey {
      return key in currentFilters;
    }

    function isSelectionFilter(filter: FilterValue): filter is SelectionFilterValue {
      return 'selected' in filter;
    }

    Object.entries(filterMappings.prescriptions).forEach(([filterKey, mappedKey]) => {
      if (isFilterKey(filterKey) && currentFilters[filterKey] && isSelectionFilter(currentFilters[filterKey]) && currentFilters[filterKey].selectedIds?.length > 0) {
        additionalFilters[mappedKey] = currentFilters[filterKey].selectedIds;
      }
    });

    return additionalFilters;
  }, [currentFilters]);

  //! обновление всего списка при редактировании записи
  useEffect(() => {
    if (idUpdateViolation || idUpdateFormPres) {
      setLocalPrescriptions([]);
      setLocalViolations([]);
      setCurrentPage(1);
      setCurrentPageViolations(1);

      setFilterChangeCounter((prev) => prev + 1);
      setFilterChangeCounterViolations((prev) => prev + 1);
    }
  }, [idUpdateFormPres, idUpdateViolation]);

  //! обновление пустой на зполненную
  // useEffect(() => {
  //   if (lastIDForm && lastIDForm > 0) {
  //     getItemsRequest({
  //       listName: prescriptionGos,
  //       filters: { ID: lastIDForm },
  //       anySite: UrlGOS,
  //     }).then((result) => {
  //       if (result) {
  //         const newItem = modifiedItemsState(result.items, prescriptionGos)[0];
  //         setLocalPrescriptions((prev) => [newItem, ...prev]);
  //       }
  //     });
  //   }
  // }, [lastIDForm]);

  // useEffect(() => {
  //   if (idDeleteFormPres) {
  //     setLocalPrescriptions([]);
  //     setCurrentPage(1);
  //   }
  // }, [idDeleteFormPres]);

  //! изменение фильтров
  useEffect(() => {
    const filtersChanged = JSON.stringify(currentFilters) !== JSON.stringify(prevFilters);

    if (filtersChanged) {
      setPrevFilters(currentFilters);
      setCurrentPage(1);
      setFilterChangeCounter((prev) => prev + 1);
      setLocalPrescriptions([]);
    }
  }, [currentFilters, prevFilters]);

  //! Загрузка данных при изменении фильтров
  useEffect(() => {
    if (filterChangeCounter > 0) {
      const mainFilters = getFormattedFilters();
      const isAppend = currentPage > 1;

      dispatch(
        fetchData(
          'gos-prescriptions',
          mainFilters,
          {
            page: currentPage,
            pageSize: itemsPerPage,
          },
          isAppend
        )
      );
    }
  }, [dispatch, filterChangeCounter, currentPage, getFormattedFilters, itemsPerPage]);

  useEffect(() => {
    setFilterChangeCounter(1);
    setFilterChangeCounterViolations(1);
  }, []);

  //! загрузка следующей страницы prescriptions
  useEffect(() => {
    if (!prescriptionsLoading && hasNextPage && currentPage > 0) {
      setCurrentPage((prev) => prev + 1);
      setFilterChangeCounter((prev) => prev + 1);
    }
  }, [prescriptionsLoading, hasNextPage, currentPage]);

  //! Загрузка данных violations при изменении счетчика
  useEffect(() => {
    if (filterChangeCounterViolations > 0) {
      const isAppend = currentPageViolations > 1;

      dispatch(
        fetchData(
          'gos-violations',
          {},
          {
            page: currentPageViolations,
            pageSize: itemsPerPage,
          },
          isAppend
        )
      );
    }
  }, [dispatch, filterChangeCounterViolations, currentPageViolations, itemsPerPage]);

  //! загрузка следующей страницы violations
  useEffect(() => {
    if (!violationsLoading && hasNextPageViolations && currentPageViolations > 0) {
      setCurrentPageViolations((prev) => prev + 1);
      setFilterChangeCounterViolations((prev) => prev + 1);
    }
  }, [violationsLoading, hasNextPageViolations, currentPageViolations]);


  useEffect(() => {
    if (prescriptionsData && prescriptionsData.length > 0) {
      const userEmails = prescriptionsData
        .flatMap((prescription: any) => {
          const emails = [prescription.ResponsibleEmail];
          if (prescription.InterestedPartiesEmails && Array.isArray(prescription.InterestedPartiesEmails)) {
            emails.push(...prescription.InterestedPartiesEmails);
          }
          return emails;
        })
        .filter(Boolean);

      if (userEmails.length > 0) {
        dispatch(addUsers(userEmails));
      }
    }
  }, [prescriptionsData, dispatch]);

  useEffect(() => {
    if (prescriptionsData && prescriptionsData.length > 0) {
      // Сортировка по убыванию id (новые записи сверху)
      const sortedData = [...prescriptionsData].sort((a, b) => b.id - a.id);
      setLocalPrescriptions(sortedData);
    }
  }, [prescriptionsData]);

  useEffect(() => {
    if (ViolationsGos && ViolationsGos.length > 0) {

      const sortedViolations = [...ViolationsGos].sort((a, b) => b.id - a.id);
      setLocalViolations(sortedViolations);
    }
  }, [ViolationsGos]);

  const PanelStatusData = useMemo(() => {
    return users ? generatePrescriptions(localPrescriptions, localViolations, actions, users) : [];
  }, [localPrescriptions, localViolations, actions, users]);

  if (userStatus === 'LOADING' || userStatus === 'IDLE') {
    return <div className='flex justify-center items-center h-full'>Загрузка...</div>;
  }

  if (!user.infoGOS.editor && !user.infoGOS.admin) {
    return <NoAccess />;
  }

  return (
    <div className='flex justify-between w-full h-full'>
      <div className='w-[320px] bg-white'>
        <FilterForPlanAction
          onFiltersChange={handleFiltersChange}
          filterConfigs={filterConfigs}
          filtersMap={filtersMap}
          initialFilters={initialFilterPrescriprion}
          filtersOpen={initialFilterOpenPrescriprion}
          filtersConfig={filterConfigPrescriprion}
          responsibleFil={true}
          heightFilter={'h-[calc(100vh-10px)]'}
        />
      </div>
      <div className='flex-1 min-w-0 m-6'>
        <PageHead data={PanelStatusData} />

        <PanelStatus
          data={PanelStatusData}
          filters={{
            statusPrescription:
              currentFilters.statusPrescription?.selected || currentFilters.statusPrescription?.selectedIds?.map((id) => prescriptionStatusFilter.find((status) => status.id === id)?.Title),
            status: currentFilters.status?.selected || currentFilters.status?.selectedIds?.map((id) => actionStatusFilter.find((status) => status.id === id)?.Title),
            actualClosingDateRange: currentFilters.dataOfPrescription,
          }}
        />

        <HorizontalTable
          data={PanelStatusData}
          dataHead={TitleHeadPrescription}
          isLoading={prescriptionsLoading || !users}
          hasMorePages={hasNextPage}
          filters={{
            statusPrescription:
              currentFilters.statusPrescription?.selected || currentFilters.statusPrescription?.selectedIds?.map((id) => prescriptionStatusFilter.find((status) => status.id === id)?.Title),
            status: currentFilters.status?.selected || currentFilters.status?.selectedIds?.map((id) => actionStatusFilter.find((status) => status.id === id)?.Title),
            actualClosingDateRange: currentFilters.dataOfPrescription,
          }}
        />
      </div>
    </div>
  );
}

export default Gos;
